var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ loader: true, fadeout: !_vm.isLoading }},[_c('img',{attrs:{"src":require("@/assets/img/loading.gif"),"alt":"Loading"}}),_vm._v(" Cargando información ")])
}
var staticRenderFns = []

export { render, staticRenderFns }